import React from "react";
import { useApp } from "@/contexts/AppContext";
import { LANGUAGES } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LangSwitcher({ variant = "default" }) {
  const { lang, setLang } = useApp();
  const current = LANGUAGES.find((l) => l.code === lang);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-[#E5EBE7] bg-white hover:bg-[#FDFBF7] transition text-sm font-medium"
      >
        <Globe className="w-4 h-4" />
        <span>{current?.flag}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={l.code === lang ? "bg-[#FDFBF7] font-semibold" : ""}
          >
            <span className="mr-2 text-xs text-[#5C6B61]">{l.flag}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
